import { render, staticRenderFns } from "./LastChange.vue?vue&type=template&id=5c512110"
import script from "./LastChange.vue?vue&type=script&lang=js"
export * from "./LastChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports